<template>
  <div class="app-container">
    <BjRouteTabs />
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :auto-fetch="false"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingBaseDataLov.valueSet')" prop="lovCode">
            <BjSelectLovHeader
              v-model="queryParams.lovCode"
              :default-options="defaultLovData"
              :clearable="false"
            />
          </el-form-item>
        </el-col>

        <el-col :span="colSpan">
          <el-form-item :label="$t('SettingBaseDataLov.name')" prop="meaning">
            <BjInput
              v-model="queryParams.meaning"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.statusText')" prop="enabledFlag">
            <el-select
              v-model="queryParams.enabledFlag"
              class="full-width"
              :placeholder="$t('chooseText')"
              clearable
            >
              <el-option
                v-for="(item, index) in STATUS_ENABLED_NUM"
                :key="index"
                :label="$t(item.label)"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button
            v-permission:SettingBaseDataLovIndex_Delete
            type="primary"
            :disabled="tableOperationProp.notSelected"
            class="delete-btn"
            @click="onDeleteSelected"
            >{{ $t('delText') }}</el-button
          >
          <el-button
            v-permission:SettingBaseDataLovIndex_Add
            type="primary"
            class="main-btn"
            @click="onAdd"
            >{{ $t('addText') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />

              <el-tag
                v-else-if="col.prop === 'enabledFlag'"
                :type="scope.row.enabledFlag ? 'success' : 'info'"
                >{{ $t(STATUS_ENABLED_NUM.bjGet(scope.row.enabledFlag)) }}</el-tag
              >
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="props">
              <el-button
                v-permission:SettingBaseDataLovIndex_Edit
                type="text"
                class="edit-btn"
                @click="onEdit(props.row)"
                >{{ $t('editText') }}</el-button
              >
              <el-button
                v-if="props.row.enabledFlag"
                v-permission:SettingBaseDataLovIndex_Status
                type="text"
                @click="onStatus(0, props.row)"
                >{{ $t('disableText') }}</el-button
              >
              <el-button
                v-if="!props.row.enabledFlag"
                v-permission:SettingBaseDataLovIndex_Status
                type="text"
                @click="onStatus(1, props.row)"
                >{{ $t('enableText') }}</el-button
              >
              <el-button
                v-permission:SettingBaseDataLovIndex_Delete
                :disabled="!!props.row.enabledFlag"
                type="text"
                class="delete-btn"
                @click="onDelete(props.row)"
                >{{ $t('delText') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>

    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { baseDataApi } from '@/api';
import { STATUS_ENABLED_NUM } from '@/utils/constants';
import DataForm from './components/DataForm.vue';
const LOVCODE = 'SCHL.CHANNEL_TYPE';
export default {
  name: 'SettingBaseDataLov',
  components: {
    DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      STATUS_ENABLED_NUM,
      queryApi: baseDataApi.getLovValuesByLovId,
      // 查询参数
      queryParams: {
        lovCode: LOVCODE,
        lovName: null,
        lovId: null,
        value: null,
        meaning: null,
      },
      labelsVersion: 11,
      labelList: [
        { label: 'SettingBaseDataLov.table.name', prop: 'meaning', isCheck: true, disabled: false },
        { label: 'SettingBaseDataLov.table.code', prop: 'value', isCheck: true, disabled: false },
        { label: 'SettingBaseDataLov.table.sort', prop: 'orderSeq', isCheck: true, disabled: false },
        { label: 'table.statusText', prop: 'enabledFlag', isCheck: true, disabled: false },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 165 },
      ],
      selectedRow: null,
      defaultLovData: {},
    };
  },
  watch: {
    'queryParams.lovCode': {
      handler() {
        this.getLovCode();
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    getLovCode() {
      baseDataApi.getLovHeadersByLovCode({ lovCode: this.queryParams.lovCode }).then(res => {
        if (res.lovId) {
          this.queryParams.lovId = res.lovId;
          this.defaultLovData = res;
          this.reFresh();
        }
      });
    },
    /** 新增 */
    onAdd() {
      this.$refs.DataForm.show({
        lovCode: this.queryParams.lovCode,
        lovId: this.queryParams.lovId,
      });
    },
    /** 编辑操作 */
    onEdit(row) {
      this.$refs.DataForm.show(this.$lodash.clone(row));
    },
    /** 禁用 */
    onStatus(flag, row) {
      const TEXT = this.$t(STATUS_ENABLED_NUM.bjGet(flag));
      this.$confirm(`${this.$t('toast.youAreTipText')} ${TEXT} ${row.meaning}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            ...row,
            enabledFlag: flag,
          });
        })
        .catch(() => {});
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(`${this.$t('toast.youAreDelTipText')} ${row.meaning}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi([row]);
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }

      if (this.selectedRows.some(e => e.enabledFlag == 1)) {
        this.$message.warning(this.$t('toast.delEnabledTipText'));
        return;
      }

      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi(this.selectedRows);
        })
        .catch(() => {});
    },
    operationApi(API_DATA) {
      baseDataApi.updateLovValues(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    batchDeleteApi(API_DATA) {
      baseDataApi.deleteLovValues(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
